import { post, get } from '@api/config/$ajax.js';
import { getErpHost } from '@/utils/domainHelper.js';

const API_HOST = getErpHost();

const setCommonConfigItem = ({ id, key, value, ifCompany = false }) => {
    return new Promise((resolve, reject) => {
        post(API_HOST + '/index/common/config/update', {
            id,
            key,
            value,
            ifCompany,
        }, {isNeedLoading: false}).then(({data}) => {
            resolve(data);
        }).catch(json => {
            reject(json);
        })
    });
};
const getCommonConfigItem = ({ type, key }) => {
    if (!type || !key) {
        return Promise.reject('type && key is required');
    }
    return new Promise((resolve, reject) => {
        get(API_HOST + '/index/common/config/get', {
            [type]: key
        }, {isNeedLoading: false}).then(({data}) => {
            resolve(data);
        }).catch(json => {
            reject({});
        })
    });
};

const KeyIdMap = {};

class DefineCommonConfig {
    constructor(key, value = {}) {
        this.key = key;
        this.value = value;
        if (!DefineCommonConfig._singleton) {
            DefineCommonConfig._singleton = this;
        }
        return DefineCommonConfig._singleton;
    }
    async get(...arg) {
        let type = '';
        let key = '';
        if (arg[0] === 'key' || arg[0] === 'id') {
            type = arg[0];
            key = arg[1];
        } else {
            type = 'key';
            key = arg[0];
        }

        if (key) {
            let data = {};
            if (type === 'id') {
                data = Object.values(this.value).filter(item => {
                    return item.id === arg[1];
                })[0];
            } else if (type === 'key') {
                data = this.value[key];
            }

            if (!data) {
                data = await getCommonConfigItem({ type, key });
                this.set(data, false);
            }
            try {
                return {
                    ...data,
                    value: JSON.parse(data.value),
                };
            } catch (err) {
                return data || {};
            }
        } else {
            return this.value;
        }
    }
    getAll() {
        return new Promise((resolve, reject) => {
            get(API_HOST + '/index/common/config/getList').then(({data}) => {
                const dataMap = {};
                data.forEach(item => {
                    const { key, value } = item;
                    try {
                        item.value = JSON.parse(value);
                    } catch (err) {
                        console.log(key, err);
                    }
                    dataMap[key] = item;
                });
                resolve(dataMap);
            }).catch(json => {
                reject({});
            })
        });
    }
    set(data, isFetch = true) {
        return new Promise((resolve, reject) => {
            if (Object.getPrototypeOf(data) === Object.prototype) {
                if (isFetch) {
                    const { value } = data;
                    setCommonConfigItem({ ...data, value: JSON.stringify(value) }).then(res => {
                        const newData = { ...data, id: res.id };
                        this.setCacheItem(newData);
                        resolve(newData);
                    });
                } else {
                    this.setCacheItem(data);
                    resolve(data);
                }
            } else {
                reject({});
                throw new Error(`[window.${this.key}: set] 数据格式错误`);
            }
        });
    }
    async getByKey(key){
        const { id = '', value } = await this.get(key);
        if(id){
            KeyIdMap[key] = id;
        }
        return value;
    }
    setByKey(key, value, ...args){
        let id = KeyIdMap[key] || '';
        return this.set({
            id,
            key,
            value
        },...args);
    }
    setCacheItem(data) {
        const { key, id } = data;
        if (key && id) {
            this.value = Object.assign(this.value, { [key]: data });
        }
    }
}

export const defineCommonConfig = (key, data = {}) => {
    Object.defineProperty(window, key, {
        configurable: false,
        get() {
            return new DefineCommonConfig(key, data);
        },
    });
};